import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateLoader implements TranslateLoader {
  private readonly translationsUrl = '/assets/i18n/translations.json';

  readonly httpClient = inject(HttpClient);

  getTranslation(lang: string): Observable<{ [key: string]: string }> {
    return this.httpClient.get(this.translationsUrl).pipe(
      map((translations: any) => this.flattenTranslations(translations, lang)),
      catchError((error) => {
        console.error('Translation load error:', error);
        return of({});
      }),
    );
  }

  private flattenTranslations(node: any, lang: string, path: string = ''): { [key: string]: string } {
    let result: { [key: string]: string } = {};

    Object.keys(node).forEach((key) => {
      const currentPath = path ? `${path}.${key}` : key;

      if (node[key] && typeof node[key] === 'object' && node[key][lang] === undefined) {
        result = {
          ...result,
          ...this.flattenTranslations(node[key], lang, currentPath),
        };
      } else if (node[key][lang]) {
        result[currentPath] = node[key][lang];
      } else {
        console.warn(`Missing translation for "${currentPath}" in ${lang}`);
        result[currentPath] = currentPath;
      }
    });

    return result;
  }
}
